<div class="survey-list">
  <div class="list-header">
    <div class="header-title">
      <h3 translate>WORK_ENVIRONMENT_SURVEY.SURVEYS.TAB</h3>
      <span class="record-count">
        {{
          "WORK_ENVIRONMENT_SURVEY.SURVEYS.COUNT"
            | translate: { count: surveys.length }
        }}
      </span>
    </div>
    <div class="header-actions">
      <button type="button" class="btn btn-success" (click)="createSurvey()">
        <i class="fa fa-plus" aria-hidden="true"></i>
        <span translate>WORK_ENVIRONMENT_SURVEY.SURVEYS.NEW</span>
      </button>
    </div>
  </div>

  <!--
    Stand-in for distribution, which does not exist yet: one shared link per
    survey instead of one per respondent, and nothing is sent anywhere. Remove
    this notice when real per-respondent links are handed out.
  -->
  <div class="preview-notice">
    <i class="fa fa-info-circle" aria-hidden="true"></i>
    <span translate>
      WORK_ENVIRONMENT_SURVEY.SURVEYS.PREVIEW_LINK_NOTICE
    </span>
  </div>

  <div class="table-view card">
    <p-table
      [value]="surveys"
      [loading]="isLoading"
      styleClass="p-datatable-striped"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "TITLE" | translate }}</th>
          <th>{{ "START_DATE" | translate }}</th>
          <th>{{ "END_DATE" | translate }}</th>
          <th>{{ "WORK_ENVIRONMENT_SURVEY.REMINDER_DATE" | translate }}</th>
          <th>{{ "WORK_ENVIRONMENT_SURVEY.PARTICIPANTS" | translate }}</th>
          <th>{{ "ACTIONS" | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-survey>
        <tr>
          <td>{{ survey.Title }}</td>
          <td>{{ survey.StartDate | date: "dd.MM.yyyy" }}</td>
          <td>{{ survey.EndDate | date: "dd.MM.yyyy" }}</td>
          <td>{{ survey.ReminderDate | date: "dd.MM.yyyy" }}</td>
          <td>{{ survey.ParticipantCount }}</td>
          <td>
            <div class="action-buttons">
              <button
                type="button"
                class="btn btn-sm btn-success"
                [disabled]="deletingSurveyId === survey.Id"
                [pTooltip]="
                  'WORK_ENVIRONMENT_SURVEY.SURVEYS.OPEN_HINT' | translate
                "
                tooltipPosition="top"
                (click)="openAsRespondent(survey)"
              >
                <i class="fa fa-play" aria-hidden="true"></i>
                <span translate>WORK_ENVIRONMENT_SURVEY.SURVEYS.OPEN</span>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                [disabled]="deletingSurveyId === survey.Id"
                [pTooltip]="
                  'WORK_ENVIRONMENT_SURVEY.SURVEYS.COPY_LINK' | translate
                "
                tooltipPosition="top"
                (click)="copyRespondentLink(survey)"
              >
                <i class="fa fa-link" aria-hidden="true"></i>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                [disabled]="deletingSurveyId === survey.Id"
                [pTooltip]="'EDIT' | translate"
                tooltipPosition="top"
                (click)="editSurvey(survey)"
              >
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-danger"
                [disabled]="deletingSurveyId === survey.Id"
                [pTooltip]="'DELETE' | translate"
                tooltipPosition="top"
                (click)="confirmDelete(survey)"
              >
                <i
                  class="fa"
                  [ngClass]="
                    deletingSurveyId === survey.Id
                      ? 'fa-spinner fa-spin'
                      : 'fa-trash'
                  "
                  aria-hidden="true"
                ></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center">
            <div class="empty-state">
              <p class="empty-state-title" translate>
                WORK_ENVIRONMENT_SURVEY.NO_SURVEYS_TITLE
              </p>
              <p class="empty-state-body" translate>
                WORK_ENVIRONMENT_SURVEY.NO_SURVEYS_BODY
              </p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<survey-wizard
  [(visible)]="wizardVisible"
  [surveyId]="wizardSurveyId"
  (saved)="onWizardSaved()"
></survey-wizard>

<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
